import React from "react";

export const getReportsSteps = () => [
  {
    target: () => document.querySelector('[data-tour-id="reports-tab"]'),
    title: "Aba de Relatórios",
    description: "Acesse relatórios do projeto e filtros.",
    nextButtonProps: { children: 'Próximo', onClick: () => { const el = document.querySelector('[data-tour-id="reports-tab"]'); if (el) el.click(); } }
  },
  {
    target: () => document.querySelector('[data-tour-id="create-report-btn"]'),
    title: "Criar novo relatório",
    description: "Abra o seletor de fonte de dados.",
    nextButtonProps: { children: 'Próximo', onClick: () => window.dispatchEvent(new Event('tour-open-create-report-modal')) }
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-selector-search"]'),
    title: "Buscar sincronização",
    description: "Filtre a lista e selecione a fonte de dados.",
    prevButtonProps: { children: 'Anterior', onClick: () => window.dispatchEvent(new Event('tour-close-create-report-modal')) }
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-card"]'),
    title: "Selecionar integração",
    description: "Clique em uma sincronização ativa para continuar.",
  },
  {
    target: () => document.querySelector('[data-tour-id="sync-selector-next"]'),
    title: "Avançar para modelos",
    description: "Após escolher a sincronização, avance para os modelos.",
  },
  {
    target: () => document.querySelector('[data-tour-id="template-search"]'),
    title: "Buscar modelo",
    description: "Pesquise por um modelo existente ou use o relatório em branco.",
  },
  {
    target: () => document.querySelector('[data-tour-id="template-blank"]'),
    title: "Relatório em Branco",
    description: "Escolha iniciar sem template.",
  },
  {
    target: () => document.querySelector('[data-tour-id="template-card"]'),
    title: "Selecionar modelo",
    description: "Opção de iniciar com um template pronto.",
  },
  {
    target: () => document.querySelector('[data-tour-id="go-to-builder"]'),
    title: "Abrir no Construtor",
    description: "Siga para o builder para editar seu relatório.",
  },
  {
    target: () => document.querySelector('[data-tour-id="share-report-btn"]'),
    title: "Compartilhar relatório",
    description: "Abra a modal de compartilhamento e opções.",
  },
  {
    target: () => document.querySelector('[data-tour-id="report-edit-btn"]'),
    title: "Ferramentas de edição",
    description: "Entre no Builder para editar e personalizar.",
  },
];